module.exports = __webpack_public_path__ + "img/download-2-1.d54f37f8.png";